import { Component } from "preact";
import { isNullOrUndefined } from "util";
import { isNumber, numberWithCommas, numberWithoutCommas, getKey, getCurrencySymbol } from "../../../../utils/utility";
import { preventDefault, validateAmountWeb, showRupee } from "../../../../utils/common";
import { logEvent } from "../../../../utils/logger";
import style from "./style";
import { locale } from "../../../../utils/i18n";

export default class PartialAmountInput extends Component {
  constructor(props) {
    super(props);
    this.maxValue = getKey(props, "partialAmountData.payableAmount", "");
    this.state = { inputValue: this.maxValue, showAmountInput: false, isFullAmount: true, isPartialAmount: false };
    this.amtInput = "";
    this.updateValue(this.maxValue);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isError !== this.props.isError || nextProps.errorName !== this.props.errorName) {
      let error = nextProps.errorName;
      const fieldName = this.props.name;
      if (Number(numberWithoutCommas(this.state.inputValue)) > Number(numberWithoutCommas(this.maxValue))) {
        error = locale("error.partial.amount.max");
      } else if (
        error &&
        (error.indexOf(fieldName) === 0 && error.toLowerCase().indexOf(`${fieldName.toLowerCase()} amount`) !== 0)
      ) {
        error = error.replace(fieldName, "Amount");
      }
      this.setState({ isError: nextProps.isError, errorName: error });
    }
  }

  validateNumberInput = event => {
    if (!isNumber(event)) {
      preventDefault(event);
    }
  };

  updateValue = amt => {
    this.props.updateFormValue(this.props.index, numberWithoutCommas(amt));
    this.props.updateAmount(Number(numberWithoutCommas(amt)));
  };

  clearErrors = () => {
    if (this.state.isError && !isNullOrUndefined(this.props.index)) {
      this.props.clearErrorData(this.props.index);
    }
    logEvent({ eventType: "clicked_form_field", eventValue: "amount form field", fieldName: this.props.name });
  };

  validateWebAmount = event => {
    if (!validateAmountWeb(event)) {
      return preventDefault(event);
    }
  };

  setAmountField = event => {
    if (event && event.target) {
      let showRs = showRupee(event, false);
      const amt = numberWithCommas(event.target.value);
      if (amt === "") {
        showRs = showRupee(event, false);
      }
      this.setState({ showRupeeInAmount: showRs, inputValue: amt });
      this.updateValue(amt);
    }
  };

  pasteNumber = event => {
    setTimeout(() => {
      if (event && event.target) {
        const number = event.target.value;
        if (isNumber(number)) {
          this.setAmountField(event);
        } else {
          event.target.value = "";
        }
      }
    }, 0);
  };

  selectMode = val => {
    if (val === "full") {
      this.setState({
        showAmountInput: false,
        inputValue: this.maxValue,
        isFullAmount: true,
        isPartialAmount: false,
        showRupeeInAmount: false
      });
      this.updateValue(this.maxValue);
    } else {
      this.setState({ showAmountInput: true, inputValue: "", isFullAmount: false, isPartialAmount: true });
      this.amtInput && this.amtInput.focus();
      this.updateValue("");
    }
  };

  render(
    { name, constraints, placeholder, subText },
    { inputValue, showAmountInput, showRupeeInAmount, isPartialAmount, isFullAmount, isError, errorName }
  ) {
    const maxLength = constraints.maxLength ? constraints.maxLength : "";
    return (
      <div>
        <p className={style["select-head"]}>{locale("form.select.pay")}</p>
        <span className={style["radio-inp"]} onClick={() => this.selectMode("full")}>
          <label className="custom-radio">
            <input
              className={style.radio}
              type="radio"
              name="authenticatemode"
              value={locale("form.pay.full")}
              checked={isFullAmount}
            />
            <span className="c-mark" area-hidden="true" />
          </label>
          <span className="pos-r bold">{locale("form.pay.full")}</span>
        </span>
        <span className={style["radio-inp"]} onClick={() => this.selectMode("partial")}>
          <label className="custom-radio">
            <input
              className={style.radio}
              type="radio"
              name="authenticatemode"
              value={locale("form.pay.partial")}
              checked={isPartialAmount}
            />
            <span className="c-mark" area-hidden="true" />
          </label>
          <span className="pos-r bold">{locale("form.pay.partial")}</span>
        </span>
        {showAmountInput && (
          <div className={`${style["pos-r"]} ${style["amt-section"]}`}>
            {showRupeeInAmount && (
              <span id="rupee" className={`${style["rupee-sign"]}`}>
                {getCurrencySymbol()}
              </span>
            )}
            <input
              ref={inp => (this.amtInput = inp)}
              name={name}
              type="text"
              inputmode="numeric"
              value={inputValue}
              placeholder={placeholder}
              maxlength={maxLength}
              onKeyDown={this.validateWebAmount}
              onKeyUp={this.setAmountField}
              onFocus={this.clearErrors}
              className={showRupeeInAmount ? style["has-val"] : ""}
              onPaste={this.pasteNumber}
              autocomplete="off"
            />
            {subText && <p className="input-info">{subText}</p>}
            {isError && (
              <span className={`error ${subText ? "sub-txt-err" : ""}`} data-error-for={name}>
                {errorName}
              </span>
            )}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./form/components/inputs/partial-amount/index.js